import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideRouter } from '@angular/router';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { apiAuthInterceptor } from './core/api/api-auth.interceptor';
import { AuthService } from './core/auth/auth.service';
import { UserContextService } from './core/auth/user-context.service';
import { LocalizationService } from './core/i18n/localization.service';
import { LocalizedPaginatorIntl } from './core/i18n/localized-paginator-intl';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(MatSnackBarModule),
    provideHttpClient(withInterceptors([apiAuthInterceptor])),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [LocalizationService],
      useFactory: (localization: LocalizationService) => () => localization.init()
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthService, UserContextService],
      useFactory: (auth: AuthService, userContext: UserContextService) => () => {
        const user = auth.currentUser();
        if (auth.isAuthenticated() && user) {
          userContext.setAuthenticatedUser(user);
        } else {
          auth.clearSession();
          userContext.clearAuthenticatedUser();
        }
      }
    },
    { provide: MatPaginatorIntl, useClass: LocalizedPaginatorIntl },
    { provide: MAT_TABS_CONFIG, useValue: { animationDuration: '0ms' } }
  ]
};
